import React, { useState } from "react";

function InterviewQuestionItem({ question, answer }) {
  const [open, setOpen] = useState(false);

  return (
    <div className="iq-item">
      <div className="iq-question">
        <span>{question}</span>
        <button className="iq-toggle" onClick={() => setOpen(!open)}>
          {open ? "Hide Answer" : "Show Answer"}
        </button>
      </div>

      {open && (
        <div className="iq-answer">
          {answer}
        </div>
      )}
    </div>
  );
}

export default InterviewQuestionItem;
